import React from "react";
import { useDeleteSignMutation } from "../../../../Services/settingsAPIs/SignatureApi";
import { toast } from "react-toastify";

interface IProps {
  closeModal: any;
  signatureToDelete: any;
  setSignatures: any;
  signatures: any;
  refetchingData: any;
}

const DeleteSignatureModal: React.FC<IProps> = ({
  closeModal,
  signatureToDelete,
  setSignatures,
  signatures,
  refetchingData,
}) => {
  const [triggerDelete, { isLoading }] = useDeleteSignMutation();

  const deleteSignatureHandler = async () => {
    const id = signatureToDelete?.id;

    if (!id) {
      toast.error("Invalid ID, cannot delete signature");
      return;
    }

    try {
      // Optimistically update UI
      setSignatures(signatures.filter((item: any) => item?.id !== id));

      const response = await triggerDelete({ id });

      if (response?.error) {
        toast.error("Unable to delete signature");
        // Revert optimistic update on error
        refetchingData();
      } else {
        toast.success("Signature deleted successfully");
        closeModal(true);
        refetchingData();
      }
    } catch (error) {
      toast.error("An error occurred while deleting the signature");
      // Revert optimistic update on error
      refetchingData();
    }
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        gap: "10px",
        alignItems: "center",
      }}
    >
      <div
        style={{
          display: "flex",
          width: "100%",
          justifyContent: "end",
        }}
      >
        <i
          style={{
            fontSize: "26px",
            color: "black",
            cursor: "pointer",
          }}
          className="bi bi-x"
          onClick={closeModal}
        ></i>
      </div>

      <div style={{ color: "#3071e4", fontSize: "16px" }}>Are you sure?</div>

      <div style={{ marginBottom: "15px" }}>
        Do you really want to delete this signature? This process cannot be
        undone.
      </div>

      <div style={{ display: "flex", gap: "10px" }}>
        <button
          className="btn btn-light"
          onClick={closeModal}
          disabled={isLoading}
        >
          Cancel
        </button>

        <button
          className="btn btn-danger"
          onClick={deleteSignatureHandler}
          disabled={isLoading}
        >
          {isLoading ? "Deleting..." : "Delete"}
        </button>
      </div>
    </div>
  );
};

export default DeleteSignatureModal;
